<div class="spinner-overlay" *ngIf="cargando">
  <div class="spinner"></div>
</div>

<section class="carritoFin">
  <div class="txtNombre">
    <h2 class="titulo-evento3">CARRITO DE COMPRAS</h2>
    <hr class="linea-naranja4" />

    <br>
    <div class="seccion">

      <div class="contenedorFlex">


        <div class="espacioDetalle">
          <div>
            <div class=" lineH lato text-1">
              <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 41.png"
                alt="">
              <div class="detalle1">


                <p>Haz agregado <span class="txPt2">{{tickets?.length}} TICKETS</span> a tu carrito y cuentas con <span>
                    <countdown class="timeColor" [config]="{leftTime:240}"></countdown>
                  </span> para realizar tu compra</p>
              </div>
            </div>

            <div class="montserrat tituloEvent">
              {{evento?.nombre}}
            </div>

            <div class="lato obsEvent">
              Recuerda que a tu correo recibirás un código QR que representa tu entrada
            </div>
          </div>
        </div>
        <div class="ImgEvento">
          <img class="eventImg" src="{{darURL()}}" alt="">
        </div>

      </div>

    </div>


  </div>


    <div class="contenedorFlex2 mt-3">
      <div class="cuadroG">
        <div class="contenTxt">
          <div class="  lineH lineH2">
            <img class="logosEvents2" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 39.png"
              alt="">
            <div class="detalle2"><strong class="bold">Fecha: </strong> {{darFecha(evento)}}  </div>

          </div>
          <div class="  lineH2 ">
            <img class="logosEvents2" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 37.png"
              alt="">
            <div class="detalle2"><strong class="bold">Apertura de Puertas: </strong> {{evento?.horaApertura | horas}}
            </div>
          </div>
          <div class="  lineH2">
            <img class="logosEvents2" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 42.png"
              alt="">
            <div class="detalle2"><strong class="bold">Artistas: </strong> {{ evento?.artistas ? evento?.artistas : "Por confirmar" }}
            </div>
          </div>
          <div class="  lineH2">
            <img class="logosEvents2" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 38.png"
              alt="">
            <div class="detalle2"><strong class="bold">Lugar: </strong> {{ evento?.lugar ? evento?.lugar : "Por confirmar" }}
            </div>
          </div>
        </div>
      </div>

        <div class="cuadroGpeq">
          <div class="cdrGris">
            <p class="titPeq">Medios de pago </p>
          </div>
          <div class="txtMedios lato">
            <p>Los siguiente métodos son aceptados por All Tickets y la seguridad informática esta asegurada: </p>
          </div>
          <div class="imgMediosP">
            <div>
              <img class="logMedios" src="../../../../../assets/images/img/MC.png" alt="logoMaster">
            </div>
            <div>
              <img class="logMedios" src="../../../../../assets/images/img/VS.png" alt="logoMaster">
            </div>
            <div>
              <img class="logMedios" src="../../../../../assets/images/img/DC.png" alt="logoMaster">
            </div>
            <div>
              <img class="logMedios" src="../../../../../assets/images/img/AM.png" alt="logoMaster">
            </div>
          </div>

          <div class="imgMediosP2">
            <div>
              <img class="logMedios" src="../../../../../assets/images/img/PSE.png" alt="logoMaster">
            </div>
            <div>
              <img class="logMedios" src="../../../../../assets/images/img/NEQUI.png" alt="logoMaster">
            </div>
            <div>
              <img class="logMedios" src="../../../../../assets/images/img/DP.png" alt="logoMaster">
            </div>
          </div>
        </div>




  </div>






  <div class="txtNombre3 " >

    <div class="txtNombre2 lato text-2">
      <p>* En caso de cualquier inconveniente comunícate con nuestro numero de <span class="oranTxt"> WhatsApp </span>
        <a href="https://api.whatsapp.com/send?phone=573209644716&text=Hola%20All%20Tickets,%20me%20comunico%20con%20ustedes%C2%A0porque:" target="_blank" class="oranTxt2"> +57 320 964 4716</a>
      </p>
    </div>


    <p class="montserrat cantTq" >{{tickets?.length}}  Tickets Para la localidad  {{localidades[0]?.nombre}}</p>
    <p class="lato obsEvent2">Toma un máximo de 20 minutos en recibir tu codigo QR</p>

    <section class="tabCompra">
      <table>
        <tr >
          <th class="fondoTabla">Etapa</th>
          <th class="fondoTabla">Localidad</th>
          <th class="fondoTabla">Precio + Servicio</th>
        </tr>
        <tr *ngFor="let ticket of tickets;let i = index">
          <td class="fondoTablaDato">{{localidades[i].etapa.nombre}}</td>
          <td class="fondoTablaDato">{{localidades[i].nombre}} - {{ticket.numero_dentro_de_evento?ticket.numero_dentro_de_evento:ticket.id}}</td>
          <td class="fondoTablaDato">${{ticket.precio + ticket.servicio + ticket.servicio_iva | number: '1.0-0'}}</td>
        </tr>

      </table>
    </section>

    <div class="boxTotal" *ngIf="adicionales?.length>0">
      <div class="cajaTotales3 p-3">
        <h3 class="font-vaca montserrat cantTq fs-18">¿Deseas agregar alguno de estos servicios?</h3>

        <table>
          <tr >
            <th class="fondoTabla">Nombre</th>
            <th class="fondoTabla">Precio por ticket:</th>
            <th class="fondoTabla">Agregar</th>
          </tr>
          <tr *ngFor="let adicion of adicionales;let i=index">
            <td class="fondoTablaDato">{{adicion.nombre}}</td>
            <td class="fondoTablaDato">${{adicion.precio + adicion.servicio + adicion.servicioIva | number: '1.0-0'}}</td>
            <td class="fondoTablaDato">
              <button class="btnBoxToatl2" (click)="agregarAdicion(adicion)" *ngIf="!adicionSeleccionado(adicion)"
              type="submit">Adicionar</button>
              <ng-container *ngIf="adicionSeleccionado(adicion)">Ya agregado</ng-container>
            </td>
          </tr>

        </table>
      </div>
    </div>


    <div class="boxTotal" *ngIf="orden?.tipo==4">
      <div class="cajaAlcancias p-3">
        <h3 class="font-vaca montserrat cantTq fs-18">¿Cuál es el monto qué deseas aportar a tu alcancía? (mínimo
          {{valorTotalEstable*0.4|currency:'COP'}})</h3>

        <form #todoForm="ngForm" class="w100">
          <fieldset class="form-group">
            <input type="number" name="valorVaca" required="required" class="input-vaca form-control"
              placeholder="Valor minimo" [(ngModel)]="valorTotal" (input)="formatoNumero()">
          </fieldset>
        </form>
      </div>
    </div>



    <div class="boxTotal" *ngIf="!cuponAgregado">
      <div class="cajaTotales2 p-3">
        <h3 class="font-vaca montserrat cantTq fs-18">¿Cuentas con algún cupón? </h3>
        <form #todoForm="ngForm" class="w100" (ngSubmit)="validarCupon()">
          <fieldset class="form-group">
            <input type="string" name="cuponCodigo" required="required" class="input-vaca form-control"
              placeholder="Código del cupón" [(ngModel)]="cuponCodigo">
          </fieldset>
          <fieldset class="cajaBoton">
            <button class=" btnBoxToatl2 mt-1"> APLICAR</button>
          </fieldset>
        </form>
      </div>
    </div>

    <div *ngIf="mostrarSeguro" class="mt-3">
      <p class="seguroParrafo">
        <input type="checkbox" class="seguro-checkbox" (change)="cambiarEstadoSeguro()" [checked]="seguro"> Haz click aquí para
        cubrir con <strong> MetLife</strong> el valor de tus entradas por <strong
          class="colorNaranja">{{valorSeguro |currency:'COP'}}</strong> en caso de no poder asistir, aceptas la
        adquisición del seguro si tienes entre 18 y 65 años y <strong><a
            href="https://codigos.allticketscol.com/Terminos+y+condiciones+MetLife.pdf"
            target="_blank">Acepto términos y condiciones </a>y <a
            href="https://codigos.allticketscol.com/Clausulado+MetLife.pdf" target="_blank">Conozco el
            clausulado</a></strong>
      </p>
      <div>
        <img src="../../../../../assets/images/img/MetLife.png" class="metlife" alt="">
      </div>

    </div>

    <div class="boxTotal">
      <div class="cajaTotales">
        <div class="txtBoxTotal">
          <div *ngIf="cuponAgregado" class="montserrat colorLetra"> <strong class="total">Cupón Aplicado: </strong> {{cuponAgregado.codigoVenta}}</div>
          <div class="montserrat colorLetra"> <strong class="total">Total: </strong> {{valorTotal| currency:'COP'}}</div>
          <div class="montserrat colorLetra"><strong class="total">Cantidad: </strong> {{tickets.length}} </div>
        </div>



        <button class="action_button btnBoxToatl" (click)="openConfirmacion('Recuerda que puedes tener el seguro de MetLife para cubrir tus entradas.¿Deseas tener el seguro?')"> PAGAR</button>

      </div>
    </div>


  </div>


</section>
